function updateDate(cstmDate) {
    const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const months = [
        "January", "February", "March", "April", "May", "June", 
        "July", "August", "September", "October", "November", "December"
    ];
    
    const now = new Date();
    const tomorrow = new Date(now);
    tomorrow.setDate(now.getDate());
    
    const formattedDate = `${daysOfWeek[tomorrow.getDay()]}, ${months[tomorrow.getMonth()]} ${tomorrow.getDate()}`;
    cstmDate.innerText = formattedDate;
    
    const msUntilMidnight = new Date(now.setHours(24, 0, 0, 0)) - now;
    setTimeout(() => {
        updateDate();
        setInterval(updateDate, 24 * 60 * 60 * 1000);
    }, msUntilMidnight);
}
let cstmDate =  document.getElementById('cstmdate');
if (cstmDate){
 updateDate(cstmDate);
}